"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeContract = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_1 = require("react");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_delete_1 = require("@dzambalaorg/mui-dialog-delete");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const forms_1 = require("../../../../forms");
const wrappers_1 = require("../../../../wrappers");
const utils_1 = require("../../../../utils");
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./form/validation");
const popovers_1 = require("../../../../popovers");
const schemas_1 = require("./schemas");
const NATIVE_CONTRACTS_URL = "/native/contracts";
const NativeContract = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialValues = (0, react_1.useMemo)(() => {
        return {
            search: (0, utils_1.contractsSearchParamsCreator)(profile)[service],
            form: (0, schemas_1.nativeContractsEmptyValuesCreator)(profile)[service],
        };
    }, [service, profile]);
    const isMd = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("md"));
    const { data, isLoading, isError, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } = (0, react_hooks_1.useFetchQuery)(NATIVE_CONTRACTS_URL, { enableInfiniteScroll: isMd }, void 0, initialValues.search);
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { handleDelete } = (0, react_hooks_1.useDialogDelete)();
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const nativeContractCreate = () => {
        openDialog(dialogs_1.GlobalDialogKeys.NATIVE_CONTRACT_CREATE, initialValues.form, {
            refetch,
            initialValues: initialValues.form,
            message: "dialogs.create",
            testId: "NativeTokenDialogForm",
            filter: (0, schemas_1.nativeContractsFilter)(service),
            url: NATIVE_CONTRACTS_URL,
            validationSchema: (0, validation_1.nativeContractsValidationSchemaCreator)(service),
            componentNeedsOpen: true,
            componentProps: {
                service,
                mode: "create",
            },
        });
    };
    const nativeContractEdit = (contract) => () => {
        openDialog(dialogs_1.GlobalDialogKeys.NATIVE_CONTRACT_EDIT, contract, {
            refetch,
            initialValues: contract,
            message: "dialogs.edit",
            testId: "NativeTokenDialogForm",
            url: `${NATIVE_CONTRACTS_URL}/${contract.id}`,
            validationSchema: (0, validation_1.nativeContractsValidationSchemaCreator)(service),
            filter: (0, schemas_1.nativeContractsFilter)(service),
            prepareInitialValues: (0, schemas_1.prepareNativeContractsInitialValues)(service),
            action: ((0, jsx_runtime_1.jsx)(popovers_1.BlockchainInfoPopover, { symbol: contract.symbol, decimals: contract.decimals, chainId: contract.chainId })),
            componentNeedsOpen: true,
            componentProps: {
                service,
                mode: "edit",
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "native", "native.contracts"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.native.contracts.title", children: process.env.BUSINESS_TYPE !== types_1.BusinessType.B2B && ((0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), onClick: nativeContractCreate, "data-testid": "NativeTokenCreateButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.create" }) })) }), (0, jsx_runtime_1.jsx)(forms_1.ContractSearchForm, { service: service, initialSearchValues: initialValues.search, contractFeaturesOptions: types_1.NativeContractFeatures }), (0, jsx_runtime_1.jsx)(wrappers_1.WithCheckPermissionsListWrapper, { isLoading: !data && isLoading, isError: !data && isError, isEmpty: allRows.length === 0, count: allRows.length, children: allRows.map(contract => ((0, jsx_runtime_1.jsxs)(styled_1.ListItem, { account: account, contract: contract, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: contract.title }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { dataTestId: "ContractActionsMenuButton", children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: nativeContractEdit(contract), message: "form.buttons.edit", dataTestId: "ContractEditButton", icon: icons_material_1.Create }), (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDelete(contract), message: "form.buttons.delete", dataTestId: "ContractDeleteButton", icon: icons_material_1.Delete, disabled: contract.contractStatus === types_1.ContractStatus.INACTIVE })] })] }, contract.id))) }), !isMd && totalCount > take && ((0, jsx_runtime_1.jsx)(styled_1.StyledPagination, { shape: "rounded", page: skip / take + 1, count: Math.ceil(totalCount / take), onChange: onChangePage })), isMd && hasNextPage && (0, jsx_runtime_1.jsx)("div", { ref: loadMoreRef, style: { height: "20px", margin: "20px 0" } }), (0, jsx_runtime_1.jsx)(mui_dialog_delete_1.DeleteDialog, { url: NATIVE_CONTRACTS_URL, refetch: refetch })] }));
};
exports.NativeContract = NativeContract;
//# sourceMappingURL=index.js.map